import Anim from './components/anim';
import Appear from './components/appear';
import BlockQuote from './components/block-quote';
import Cite from './components/cite';
import CodePane from './components/code-pane';
import Code from './components/code';
import ComponentPlayground from './components/component-playground';
import Deck from './components/deck';
import { Fill } from './components/fill';
import { Fit } from './components/fit';
import Heading from './components/heading';
import Image from './components/image';
import GoToAction from './components/go-to-action';
import Layout from './components/layout';
import Link from './components/link';
import ListItem from './components/list-item';
import List from './components/list';
import Magic from './components/magic';
import Markdown from './components/markdown';
import MarkdownSlides from './components/markdown-slides';
import Notes from './components/notes';
import Quote from './components/quote';
import S from './components/s';
import Slide from './components/slide';
import SlideSet from './components/slide-set';
import TableBody from './components/table-body';
import TableHeader from './components/table-header';
import TableHeaderItem from './components/table-header-item';
import TableItem from './components/table-item';
import TableRow from './components/table-row';
import Table from './components/table';
import Text from './components/text';
import Typeface from './components/typeface';
import defaultTheme from './themes/default';
var themes = {
  // Rename from `default` to `defaultTheme` to avoid keyword issues.
  defaultTheme: defaultTheme
};
export { Anim, Appear, BlockQuote, Cite, CodePane, Code, ComponentPlayground, Deck, Fill, Fit, Heading, Image, GoToAction, Layout, Link, ListItem, List, Magic, Markdown, MarkdownSlides, Notes, Quote, S, Slide, SlideSet, TableBody, TableHeader, TableHeaderItem, TableItem, TableRow, Table, Text, Typeface, themes };


//////////////////
// WEBPACK FOOTER
// ./node_modules/spectacle/es/index.js
// module id = 2
// module chunks = 0